<template>
    <div v-if="loaded">
        <quote-client :quote-upsert-body="upsertQuoteBody" />
        <quote-info :quote-upsert="upsertQuoteBody.upsertQuote" />

        <div class="viewport">
            <md-toolbar :md-elevation="1">
                <span class="md-title">Products</span>
            </md-toolbar>

            <md-list class="md-triple-line">
                <md-list-item v-for="(quoteLineItem, index) in upsertQuoteBody.upsertQuote.quoteLines" :key="index">
                    <md-avatar>
                        <img src="web_logo.png" />
                    </md-avatar>
                    <div class="md-list-item-text">
                        <span>{{ quoteLineItem.product.name }}</span>
                        <span>{{ 'Product number: ' + quoteLineItem.product.product_number }}</span>
                        <p>{{ quoteLineItem.product.specifications.description }}</p>
                        <p>
                            {{
                                quoteLineItem.quantity +
                                ' x ' +
                                quoteLineItem.unit_price +
                                '€ = ' +
                                quoteLineItem.final_price_to_pay +
                                ' €'
                            }}
                        </p>
                    </div>
                    <md-button class="md-icon-button md-list-action" @click="deleteQuoteLine(index)">
                        <md-icon>delete</md-icon>
                    </md-button>
                </md-list-item>
                <md-divider v-if="upsertQuoteBody.upsertQuote.quoteLines.length > 0"></md-divider>
                <md-button class="md-primary" @click="showDialogUpsertProduct = !showDialogUpsertProduct">
                    <md-icon>add</md-icon>
                    Add products
                </md-button>
            </md-list>
            <md-list>
                <md-list-item>
                    <span class="md-list-item-text">Products total</span>
                    <span>{{ productTotal ? productTotal + ' €' : '' }}</span>
                </md-list-item>
                <md-list-item v-if="configuration?.quotes.placementCostEnabled">
                    <md-button
                        @click="showDialogPlacementCost = !showDialogPlacementCost"
                        class="md-primary"
                        v-if="!placementCost"
                    >
                        <md-icon>add</md-icon>
                        Add plaatsingkost
                    </md-button>
                    <md-button
                        @click="showDialogPlacementCost = !showDialogPlacementCost"
                        class="md-primary"
                        v-if="placementCost"
                        >Plaatsingkost
                    </md-button>
                    <span v-if="placementCost">{{ placementCost ? placementCost + ' €' : '' }}</span>
                </md-list-item>

                <md-list-item v-if="configuration?.quotes.discountEnabled">
                    <md-button
                        @click="showDialogDiscount = !showDialogDiscount"
                        class="md-primary"
                        v-if="!discount_amount"
                    >
                        <md-icon>add</md-icon>
                        Add korting
                    </md-button>
                    <md-button
                        @click="showDialogDiscount = !showDialogDiscount"
                        class="md-primary"
                        v-if="discount_amount"
                        >Korting
                    </md-button>
                    <span v-if="discount_amount">{{
                        this.upsertQuoteBody.upsertQuote.data.discount_amount
                            ? this.upsertQuoteBody.upsertQuote.data.discount_amount + ' €'
                            : ''
                    }}</span>
                </md-list-item>

                <md-list-item>
                    <span class="md-list-item">BTW</span>
                    <md-field class="md-list-item" style="max-width: 60px">
                        <md-select
                            v-on:input="setTotalAllQuoteLines()"
                            v-model="upsertQuoteBody.upsertQuote.data.btw_percentage"
                            name="vat"
                            id="vat"
                        >
                            <md-option value="0">0%</md-option>
                            <md-option value="0.06">6%</md-option>
                            <md-option value="0.21">21%</md-option>
                        </md-select>
                    </md-field>
                    <span>{{
                        this.upsertQuoteBody.upsertQuote.data.btw_amount
                            ? this.upsertQuoteBody.upsertQuote.data.btw_amount + ' €'
                            : ''
                    }}</span>
                </md-list-item>

                <md-list-item>
                    <span class="md-list-item-text" style="font-weight: bold">Order Total</span>
                    <span style="font-weight: bold">{{ totalQuote ? totalQuote + ' €' : '' }}</span>
                </md-list-item>

                <md-list-item v-if="configuration?.quotes.advancedPaymentEnabled">
                    <md-button
                        @click="showDialogAdvancePayment = !showDialogAdvancePayment"
                        class="md-primary"
                        v-if="!advancePayment"
                    >
                        <md-icon>add</md-icon>
                        Add voorschot
                    </md-button>
                    <md-button
                        @click="showDialogAdvancePayment = !showDialogAdvancePayment"
                        class="md-primary"
                        v-if="advancePayment"
                        >Voorschot
                    </md-button>
                    <span v-if="advancePayment">{{ advancePayment }} € {{ advancePaymentMethodLabel }}</span>
                </md-list-item>

                <md-list-item v-if="configuration?.quotes.advancedPaymentEnabled && advancePayment">
                    <span class="md-list-item-text" style="font-weight: bold">Te Betalen</span>
                    <span style="font-weight: bold">{{
                        remainingPriceToPay ? remainingPriceToPay + ' €' : '0 €'
                    }}</span>
                </md-list-item>
            </md-list>

            <md-toolbar :md-elevation="1">
                <span class="md-title md-list-item-text primary">Analyse</span>
                <md-button
                    @click="showDialogAnalyse = !showDialogAnalyse"
                    class="md-icon-button md-list-action"
                    v-if="upsertQuoteBody.upsertQuote.data.technicalFiche"
                >
                    <md-icon>edit</md-icon>
                </md-button>
            </md-toolbar>
            <md-list class="md-double-line">
                <md-button
                    @click="showAnalyseDialog()"
                    class="md-primary"
                    v-if="!this.upsertQuoteBody.upsertQuote.data.technicalFiche"
                >
                    <md-icon>add</md-icon>
                    Add analyse
                </md-button>
                <md-list-item v-if="this.upsertQuoteBody.upsertQuote.data.technicalFiche">
                    <div class="md-list-item-text">
                        <span>Analyse F: {{ upsertQuoteBody.upsertQuote.data.technicalFiche.analyse_f }}</span>
                        <span>Keer klep: {{ upsertQuoteBody.upsertQuote.data.technicalFiche.keer_klep }}</span>
                        <span>Leidingen: {{ upsertQuoteBody.upsertQuote.data.technicalFiche.leidingen }}</span>
                        <span>Stopcontact: {{ upsertQuoteBody.upsertQuote.data.technicalFiche.stopcontact }}</span>
                        <span>Afvoer: {{ upsertQuoteBody.upsertQuote.data.technicalFiche.afvoer }}</span>
                    </div>
                </md-list-item>
            </md-list>

            <md-toolbar :md-elevation="1">
                <span class="md-title md-list-item-text primary">Opmerkingen</span>
                <md-button
                    @click="showDialogRemarks = !showDialogRemarks"
                    class="md-icon-button md-list-action"
                    v-if="remarks"
                >
                    <md-icon>edit</md-icon>
                </md-button>
            </md-toolbar>
            <md-list class="md-double-line">
                <md-button @click="showDialogRemarks = !showDialogRemarks" class="md-primary" v-if="!remarks">
                    <md-icon>add</md-icon>
                    Add Remarks
                </md-button>
                <md-list-item v-if="remarks">
                    <span>{{ remarks ? remarks : '' }}</span>
                </md-list-item>
            </md-list>
            <md-toolbar :md-elevation="1">
                <span class="md-title md-list-item-text primary">Rating</span>
            </md-toolbar>
            <md-list class="md-double-line">
                <div class="md-layout-item md-list-item-text md-size-90 md-small-size-100">
                    <star-rating
                        style="margin: 10px 0"
                        v-model="upsertQuoteBody.upsertQuote.data.rating.value"
                        :max-rating="upsertQuoteBody.upsertQuote.data.rating.max"
                        :show-rating="false"
                        :star-size="25"
                    ></star-rating>
                </div>
            </md-list>
        </div>

        <md-button @click="upsertQuote" style="margin-left: 0; width: 100%" class="md-raised md-primary"
            >Save
        </md-button>
        <md-dialog :md-active.sync="showDialogPlacementCost">
            <md-dialog-title>Plaatsingkost</md-dialog-title>
            <md-dialog-content>
                <md-field>
                    <label>Plaatsingkost</label>
                    <md-input v-model="placementCost" type="number"></md-input>
                </md-field>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button @click="cancelPlacementCost()" class="md-primary">Cancel</md-button>
                <md-button @click="addPlacementCost()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showDialogDiscount">
            <md-dialog-title>Korting</md-dialog-title>
            <md-dialog-content>
                <md-switch v-model="isDiscountInPercentage" class="md-primary">Korting in %?</md-switch>
                <md-field v-if="isDiscountInPercentage">
                    <label>Korting in %</label>

                    <md-input v-if="isDiscountInPercentage" v-model="discount_percentage" type="number"></md-input>
                </md-field>
                <md-field v-if="!isDiscountInPercentage">
                    <label>Korting in EUR</label>
                    <md-input v-if="!isDiscountInPercentage" v-model="discount_amount" type="number"></md-input>
                </md-field>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button @click="cancelDiscount()" class="md-primary">Cancel</md-button>
                <md-button @click="addDiscount()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showDialogAdvancePayment">
            <md-dialog-title>Voorschot</md-dialog-title>
            <md-dialog-content>
                <md-field>
                    <label>Voorschot in EUR</label>
                    <md-input v-model="advancePayment" type="number"></md-input>
                </md-field>
                <md-field>
                    <label>Betaalmethode</label>
                    <md-select v-model="advancePaymentMethod" name="advance-payment-method" id="advance-payment-method">
                        <md-option value=""><em>Geen</em></md-option>
                        <md-option v-for="paymentMethod in paymentMethods" :key="paymentMethod" :value="paymentMethod">
                            {{ parsePaymentMethodTypeReadable(paymentMethod) }}
                        </md-option>
                    </md-select>
                </md-field>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button @click="deleteAdvancePayment()" class="md-accent">Delete</md-button>
                <md-button @click="cancelAdvancePayment()" class="md-primary">Cancel</md-button>
                <md-button @click="addAdvancePayment()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showDialogAnalyse">
            <md-dialog-title>Analyse</md-dialog-title>

            <md-dialog-content v-if="this.upsertQuoteBody.upsertQuote.data.technicalFiche">
                <md-field>
                    <label>Analyse F°</label>
                    <md-input v-model="analyse.analyse_f"></md-input>
                </md-field>
                <md-field>
                    <label>Keer klep</label>
                    <md-input v-model="analyse.keer_klep"></md-input>
                </md-field>
                <md-field>
                    <label>Leidingen</label>
                    <md-input v-model="analyse.leidingen"></md-input>
                </md-field>
                <md-field>
                    <label>Stopcontact</label>
                    <md-input v-model="analyse.stopcontact"></md-input>
                </md-field>
                <md-field>
                    <label>Afvoer</label>
                    <md-input v-model="analyse.afvoer"></md-input>
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelAnalyse()" class="md-primary">Cancel</md-button>
                <md-button @click="addAnalyse()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showDialogRemarks">
            <md-dialog-title>Opmerkingen</md-dialog-title>

            <md-dialog-content>
                <md-field>
                    <label>Opmerkingen</label>
                    <md-textarea v-model="remarks" style="min-height: 200px"></md-textarea>
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelRemarks()" class="md-primary">Cancel</md-button>
                <md-button @click="addRemarks()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog style="z-index: 9" :md-active.sync="showDialogUpsertProduct" v-if="this.upsertQuoteLine">
            <md-dialog-title>Add product</md-dialog-title>

            <md-dialog-content>
                <product-search-modal
                    @set-selected-product="setSelectedProduct($event)"
                    style="padding-left: 15px; z-index: 1000"
                >
                </product-search-modal>
                <md-field>
                    <label>Beschrijving</label>
                    <md-textarea v-model="descriptionProduct"></md-textarea>
                </md-field>
                <md-field>
                    <label
                        >Aantal
                        {{
                            upsertQuoteLine.product
                                ? '(' +
                                  upsertQuoteLine.product.pricing.unit_amount +
                                  ' ' +
                                  upsertQuoteLine.product.pricing.unit_type +
                                  ')'
                                : ''
                        }}
                    </label>
                    <md-input
                        type="number"
                        name="quantity"
                        id="quantity"
                        v-model="upsertQuoteLine.quantity"
                        @input="setTotalQuoteline()"
                    ></md-input>
                </md-field>
                <md-field>
                    <label>Stuk prijs</label>
                    <md-input
                        type="number"
                        name="price"
                        id="price"
                        v-model="upsertQuoteLine.unit_price"
                        @input="setTotalQuoteline()"
                    ></md-input>
                </md-field>
                <md-field>
                    <label>Totaal</label>
                    <md-input disabled v-model="upsertQuoteLine.final_price_to_pay"></md-input>
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelUpsertQuoteLine()" class="md-primary">Cancel</md-button>
                <md-button @click="upsertAddQuoteLine()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProductEntity, IQuoteLineEntity, IUpsertQuoteBody, QuoteApi } from '@phrospr/api-backend';
import QuoteInfo from '@/views/quote2/components/QuoteInfo.vue';
import router from '@/router';
import { quoteStore } from '@/store/quote/quote.store';
import QuoteClient from '@/views/quote2/components/QuoteClient.vue';
import ProductSearchModal from '@/components/product-search-modal/ProductSearchModal.vue';
import * as toastr from 'toastr';
import StarRating from 'vue-star-rating';
import { appStore } from '@/store';
import { calculateQuotePrices, parsePaymentMethodTypeReadable } from '@phrospr/lib-core';
import { IConfiguration, IQuoteLineCreateEntity, PaymentMethodType } from '@phrospr/lib-models';
import { overBudgetMessage, quoteAttachmentOverview } from '@/services/engine/quote-attachment.engine';

@Component({
    components: { ProductSearchModal, QuoteClient, QuoteInfo, StarRating },
})
export default class Quote extends Vue {
    loaded = false;

    showDialogPlacementCost: boolean = false;
    placementCost: number = null;

    showDialogDiscount: boolean = false;
    discount_amount: number = null;
    discount_percentage: number = null;
    isDiscountInPercentage = false;

    showDialogAdvancePayment: boolean = false;
    advancePayment: number = null;
    advancePaymentMethod: PaymentMethodType | '' = '';
    remainingPriceToPay: number = null;
    paymentMethods = Object.values(PaymentMethodType);

    showDialogAnalyse: boolean = false;
    analyse = {
        analyse_f: null,
        keer_klep: null,
        leidingen: null,
        stopcontact: null,
        afvoer: null,
    };

    showDialogRemarks: boolean = false;
    remarks: string = '';

    upsertQuoteBody: IUpsertQuoteBody;

    showDialogUpsertProduct = false;
    selectedProduct: IProductEntity;
    upsertQuoteLine: IQuoteLineCreateEntity = {
        product_id: null,
        quantity: 0,
        unit_price: 0,
        final_price_to_pay: 0,
        unit: null,
        data: {},
        product_document_free_entry: null,
    };
    descriptionProduct: string = '';

    totalQuote: number = null;
    productTotal: number = null;

    @Prop() quoteId?: number;

    constructor() {
        super();
        this.loaded = false;
        this.load();
    }

    get configuration(): Partial<IConfiguration> {
        return this.$store.state.configuration;
    }

    get advancePaymentMethodLabel(): string {
        return this.advancePaymentMethod ? parsePaymentMethodTypeReadable(this.advancePaymentMethod) : '';
    }

    private async load() {
        await quoteStore.dispatch('startQuoteUpsert', this.quoteId);
        this.upsertQuoteBody = quoteStore.state.upsertQuote;
        this.isDiscountInPercentage = this.upsertQuoteBody.upsertQuote.data.discount_percentage !== undefined;
        if (this.quoteId !== undefined) {
            const analyses = this.upsertQuoteBody.upsertQuote.data.technicalFiche;
            this.analyse = {
                analyse_f: analyses?.analyse_f ?? '',
                keer_klep: analyses?.keer_klep ?? '',
                leidingen: analyses?.leidingen ?? '',
                stopcontact: analyses?.stopcontact ?? '',
                afvoer: analyses?.afvoer ?? '',
            };
            this.remarks = this.upsertQuoteBody.upsertQuote.data.remarks;
            this.placementCost = this.upsertQuoteBody.upsertQuote.placementCost;
            this.discount_amount = this.upsertQuoteBody.upsertQuote.data.discount_amount;
            this.discount_percentage = this.upsertQuoteBody.upsertQuote.data.discount_percentage;
            this.advancePayment = this.upsertQuoteBody.upsertQuote.data.advance_payment;
            this.advancePaymentMethod = this.upsertQuoteBody.upsertQuote.data.advance_payment_method ?? '';
            await this.setTotalAllQuoteLines();
        } else {
            this.analyse = {
                analyse_f: '',
                keer_klep: '',
                leidingen: '',
                stopcontact: '',
                afvoer: '',
            };
            if (appStore.state.quoteCreateSettings) {
                const { client, planningItem } = appStore.state.quoteCreateSettings;
                this.upsertQuoteBody.lead_planning_id = planningItem.planning_item_id;
                this.upsertQuoteBody.client_id = client.client_id;
                quoteStore.commit('setSelectedClientQuote', client);
            } else quoteStore.commit('setSelectedClientQuote', null);
        }
        if (this.upsertQuoteBody.upsertQuote.data.rating === undefined) {
            this.upsertQuoteBody.upsertQuote.data.rating = { value: 0, max: 5 };
        }

        this.loaded = true;
    }

    public async upsertQuote() {
        if (this.upsertQuoteBody.upsertQuote.quoteLines.length <= 0) {
            toastr.error('Geen product lijnen geselecteerd');
            return;
        }
        if (!this.upsertQuoteBody.client_id && !this.upsertQuoteBody.newClient) {
            toastr.error('Geen klant geselecteerd');
            return;
        }
        if (!this.upsertQuoteBody.upsertQuote.data.sold_by_user_id) {
            toastr.error('Geen verkoper geselecteerd');
            return;
        }
        if (!this.upsertQuoteBody.upsertQuote.data.delivery_address) {
            toastr.error('Geen leveradres geselecteerd');
            return;
        }
        const overBudget = overBudgetMessage(
            quoteAttachmentOverview(
                this.upsertQuoteBody.upsertQuote.document_ids ?? [],
                quoteStore.state.attachments,
                quoteStore.state.attachmentBudgetBytes,
            ),
        );
        if (overBudget) {
            toastr.error(overBudget);
            return;
        }

        try {
            await QuoteApi.upsertQuote(this.upsertQuoteBody);
            await router.push({ path: `/quote/overview` });
        } catch (e) {
            // The server says why (budget listing, inactive document, ...); axios' own message
            // is only the status code.
            toastr.error(e.response?.data?.message ?? e.message);
        }
    }

    public async cancelPlacementCost() {
        this.placementCost = 0;
        this.showDialogPlacementCost = false;
    }

    public async addPlacementCost() {
        this.showDialogPlacementCost = false;
        if (typeof this.placementCost === 'string') {
            this.placementCost = parseFloat(this.placementCost);
        }
        this.upsertQuoteBody.upsertQuote.placementCost = this.placementCost;
        await this.setTotalAllQuoteLines();
    }

    public async cancelDiscount() {
        this.discount_percentage = this.upsertQuoteBody.upsertQuote.data.discount_percentage;
        this.discount_amount = this.upsertQuoteBody.upsertQuote.data.discount_amount;
        this.showDialogDiscount = false;
    }

    public async addDiscount() {
        if (this.isDiscountInPercentage) {
            this.upsertQuoteBody.upsertQuote.data.discount_percentage = parseFloat('' + this.discount_percentage);
        } else {
            this.upsertQuoteBody.upsertQuote.data.discount_percentage = undefined;
            this.upsertQuoteBody.upsertQuote.data.discount_amount = parseFloat('' + this.discount_amount);
        }
        this.showDialogDiscount = false;
        await this.setTotalAllQuoteLines();
    }

    public async cancelAnalyse() {
        this.showDialogAnalyse = false;
    }

    public parsePaymentMethodTypeReadable(paymentMethod: PaymentMethodType): string {
        return parsePaymentMethodTypeReadable(paymentMethod);
    }

    public async cancelAdvancePayment() {
        this.advancePayment = this.upsertQuoteBody.upsertQuote.data.advance_payment;
        this.advancePaymentMethod = this.upsertQuoteBody.upsertQuote.data.advance_payment_method ?? '';
        this.showDialogAdvancePayment = false;
    }

    public async addAdvancePayment() {
        this.upsertQuoteBody.upsertQuote.data.advance_payment = this.advancePayment
            ? parseFloat('' + this.advancePayment)
            : undefined;
        this.upsertQuoteBody.upsertQuote.data.advance_payment_method = this.advancePaymentMethod || undefined;
        this.showDialogAdvancePayment = false;
        await this.setTotalAllQuoteLines();
    }

    public async deleteAdvancePayment() {
        this.advancePayment = null;
        this.advancePaymentMethod = '';
        this.upsertQuoteBody.upsertQuote.data.advance_payment = undefined;
        this.upsertQuoteBody.upsertQuote.data.advance_payment_method = undefined;
        this.showDialogAdvancePayment = false;
        await this.setTotalAllQuoteLines();
    }

    public addAnalyse() {
        this.upsertQuoteBody.upsertQuote.data.technicalFiche = this.analyse;
        this.showDialogAnalyse = false;
    }

    public showAnalyseDialog() {
        if (!this.upsertQuoteBody.upsertQuote.data.technicalFiche)
            this.upsertQuoteBody.upsertQuote.data.technicalFiche = this.analyse;
        this.showDialogAnalyse = !this.showDialogAnalyse;
    }

    public async cancelRemarks() {
        this.showDialogRemarks = false;
    }

    public async addRemarks() {
        this.showDialogRemarks = false;
        this.upsertQuoteBody.upsertQuote.data.remarks = this.remarks;
    }

    public async upsertAddQuoteLine() {
        if (!this.upsertQuoteLine.product) {
            toastr.error('Geen product geselecteerd');
            return;
        }
        this.showDialogUpsertProduct = false;
        this.upsertQuoteBody.upsertQuote.quoteLines.push(this.upsertQuoteLine);
        await this.setTotalAllQuoteLines();
        this.resetUpsertQuoteLine();
    }

    public async cancelUpsertQuoteLine() {
        this.showDialogUpsertProduct = false;
        this.resetUpsertQuoteLine();
    }

    async deleteQuoteLine(index: number) {
        this.upsertQuoteBody.upsertQuote.quoteLines.splice(index, 1);
        await this.setTotalAllQuoteLines();
    }

    public resetUpsertQuoteLine() {
        this.upsertQuoteLine = {
            product_id: null,
            quantity: 0,
            unit_price: 0,
            final_price_to_pay: 0,
            product: null,
            unit: null,
            data: {},
            product_document_free_entry: null,
            cost_per_unit: null,
        };
        this.descriptionProduct = '';
    }

    public async setSelectedProduct(product: IProductEntity) {
        this.selectedProduct = product;
        this.upsertQuoteLine = {
            ...this.upsertQuoteLine,
            product: product,
            quantity: 1,
            unit_price: product.pricing.price_per_unit,
            product_id: product.product_id,
            unit: product.pricing.unit_type,
            cost_per_unit: product.pricing.cost_per_unit,
        };
        this.descriptionProduct = product.specifications.description;
        await this.setTotalQuoteline();
    }

    public setTotalQuoteline() {
        if (this.upsertQuoteLine?.quantity && this.upsertQuoteLine?.unit_price) {
            this.upsertQuoteLine.final_price_to_pay = parseFloat(
                (this.upsertQuoteLine.quantity * this.upsertQuoteLine.unit_price).toFixed(2),
            );
        }
    }

    public async setTotalAllQuoteLines() {
        const quote = this.upsertQuoteBody.upsertQuote;
        const priceResult = calculateQuotePrices(
            quote.quoteLines,
            quote.placementCost,
            quote.data.btw_percentage,
            quote.data.discount_amount,
            quote.data.discount_percentage,
            quote.data.advance_payment,
        );
        this.productTotal = priceResult.subTotalPrice;
        this.upsertQuoteBody.upsertQuote.data.discount_amount = priceResult.discountAmount;
        this.upsertQuoteBody.upsertQuote.data.btw_amount = priceResult.btwAmount;
        this.totalQuote = priceResult.finalPriceToPay;
        this.remainingPriceToPay = priceResult.remainingPriceToPay;
    }
}
</script>

<style lang="scss" scoped>
.viewport {
    max-width: 100%;
    vertical-align: top;
    overflow: auto;
    border: 1px solid rgba(#000, 0.12);
    display: inherit;
    width: -webkit-fill-available;
}
</style>
